export const selectedUnitTypeUrlSelector = ({ addLocations: { selectedUnitTypeUrl } }) => selectedUnitTypeUrl;
